import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      listItem: {
        padding: 0,
      },

      title: {
        ...tokens.fontSectionHeadline,
        color: tokens.fontColorSubtle,
        paddingInline: tokens.spacingGap200,
        textAlign: 'start',
      },

      separator: {
        display: 'block',
        borderBottom: `1px solid ${tokens.borderColorSubtle}`,

        '&:last-child': {
          display: 'none',
        },
      },
    },

    motionVariants: {
      title: {
        initial: {
          opacity: 0,
        },

        open: {
          opacity: 1,
          transition: {
            ease: 'harmonize',
            duration: 0.15,
          },
        },
      },
    },
  } as const
}
